import React, { useState } from 'react';
import { ClinicSelect } from '../../components/clinic/ClinicSelect';
import { PatientTagsSection } from '../../components/admin/PatientTagsSection';
import { useStore } from '../../store';
import { PermissionSlug } from '../../constants/featureFlags';
import type { AgencyClinicResponse } from '../../services/api';

interface PatientTagsAdminSectionProps {
  clinics: AgencyClinicResponse[];
}

export const PatientTagsAdminSection: React.FC<
  PatientTagsAdminSectionProps
> = ({ clinics }) => {
  const hasPermission = useStore(state => state.hasPermission);
  const canEdit = hasPermission(PermissionSlug.EMR_MANAGE);
  const [selectedClinicId, setSelectedClinicId] = useState(
    clinics[0]?.id ?? ''
  );

  const activeClinicId =
    clinics.find(c => c.id === selectedClinicId)?.id ?? clinics[0]?.id ?? '';

  if (clinics.length === 0) {
    return (
      <div className='rounded-md border py-8 text-center text-sm text-muted-foreground'>
        No clinics found.
      </div>
    );
  }

  return (
    <div className='space-y-6'>
      <div className='space-y-1.5'>
        <p className='text-sm text-muted-foreground'>
          Manage patient tags for this clinic
        </p>
        <div className='mt-3 w-full md:max-w-sm'>
          <ClinicSelect
            clinics={clinics}
            value={activeClinicId}
            onChange={e => setSelectedClinicId(e.target.value)}
            placeholder='Select a clinic'
          />
        </div>
      </div>
      <PatientTagsSection clinicId={activeClinicId} canEdit={canEdit} />
    </div>
  );
};

export default PatientTagsAdminSection;
